var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0086321 11.7371L0.55932 9.90057C0.662946 9.55499 0.850787 9.24047 1.10602 8.98518L8.10634 1.98439C8.21257 1.87809 8.385 1.87792 8.49145 1.984C8.49158 1.98413 8.49171 1.98426 8.49184 1.98439L10.0144 3.50731C10.1208 3.61385 10.1208 3.78632 10.0144 3.89286L3.01438 10.8934C2.75904 11.1489 2.44415 11.3369 2.09801 11.4408L0.263232 11.9913C0.155057 12.0237 0.0410632 11.9624 0.00861961 11.8544C-0.00287743 11.8161 -0.00287313 11.7753 0.0086321 11.7371ZM11.0119 0.238747L11.7613 0.988053C12.0796 1.30649 12.0796 1.82209 11.7613 2.14053L10.8479 3.05375C10.7421 3.15967 10.5703 3.15987 10.4642 3.0542C10.464 3.05405 10.4639 3.0539 10.4637 3.05375L8.94599 1.53614V1.53614C8.83985 1.42997 8.83985 1.25802 8.94599 1.15185L9.85944 0.238638C10.177 -0.0790989 10.6924 -0.0796113 11.0106 0.237495C11.011 0.237912 11.0114 0.23833 11.0119 0.238747Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2a0259740d1ffd5cbeda4c9e6747204b.svg";
export { ForwardRef as ReactComponent };